import { render, staticRenderFns } from "./PlaceholderSection.vue?vue&type=template&id=1355d794&"
import script from "./PlaceholderSection.vue?vue&type=script&lang=ts&"
export * from "./PlaceholderSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports